







































import {
  defineComponent, computed, PropType,
} from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import NavigationLink from '~/components/NavigationLink.vue';
import { INavigationTab } from './types';

export default defineComponent({
  name: 'SubSection',
  inheritAttrs: false,
  components: {
    FCImage,
    NavigationLink,
  },
  props: {
    subSection: {
      type: Object as PropType<INavigationTab>,
      required: true,
    },
  },
  setup(props) {
    const defaultImage = computed(() => props.subSection?.defaultImage || {});
    const content = computed(() => props.subSection?.content || []);

    return {
      defaultImage,
      content,
      isValid: computed(() => Object.keys(defaultImage.value).length !== 0 && content.value.length !== 0),
    };
  },
});
